export const USER_SEARCH_OPTIONS = {
  user: ["fullName"],
  id: ["id"],
  phone: ["mobileNumber"],
};

export const OFFICER_SEARCH_OPTIONS = {
  officer: ["fullName"],
};

export const USER_TABLE_HEADERS = [
  { title: "ID", sortArrow: true, sortBy: "number", address: ["id"] },
  {
    title: "Name",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["fullName"],
  },
  {
    title: "Loan Balance",
    sortArrow: true,
    sortBy: "number",
    address: ["loanBalance"],
  },
  {
    title: "Pending Balance",
    sortArrow: true,
    sortBy: "number",
    address: ["pendingBalance"],
  },
  {
    title: "Total Balance",
    sortArrow: true,
    sortBy: "number",
    address: ["totalBalance"],
  },
  { title: "Details" },
  { title: "Action" },
];


export const OFFICER_TABLE_HEADERS = [
  { title: "SN" },
  {
    title: "Officer Name",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["fullName"],
  },
  {
    title: "Created At",
    sortArrow: true,
    sortBy: "date",
    address: ["createdAt"],
  },
];
